import { FormDataConsumer, Labeled, useInput } from 'react-admin';
import ReactEditorJS from 'react-editor-js';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import get from 'lodash/get';

import { EDITOR_TOOLS } from './plugins';

const useStyles = makeStyles(theme => ({
  root: { boxSizing: 'border-box', padding: '0 12px 12px' },
  upload: {
    '& .previews': { display: 'none' }
  },
  progress: { width: '100%' }
}));

export default function CustomEditor(props: any) {
  const { className, tools, helperText, source, ...rest } = props;

  const classes = useStyles(props);

  const {
    input: { onChange },
    meta,
    isRequired
  } = useInput(props);

  const customTools = tools ? Object.entries(EDITOR_TOOLS).reduce((acc, [k, v]) => {
    if (tools.includes(k))
      return {...acc, v}
    return acc
  }, {}) : EDITOR_TOOLS;

  return (
    <FormControl
      fullWidth
      variant="filled"
      margin="dense"
      className={classnames(
        classes.root,
        className,
        'MuiFilledInput-root',
        'MuiFilledInput-underline'
      )}
    >
      <Labeled {...rest} source={source} isRequired={isRequired} meta={meta}>
        <FormDataConsumer>
          {({ formData }) => {
            const value = get(formData, source);

            return (
              <ReactEditorJS
                tools={customTools}
                i18n={{
                  messages: {
                    toolNames: {
                      Hyperlink: 'Link'
                    },
                    tools: {
                      hyperlink: {
                        Save: 'Salvar',
                        'Select target': 'Selecionar destino',
                        'Select rel': 'Selecionar rel'
                      },
                      AnyButton: {
                        'Button Text': 'Texto do botão',
                        'Link Url': 'Link do botão',
                        'Set': 'Definir',
                        'Default Button': 'Botão padrão',
                      }
                    }
                  }
                }}
                data={value}
                onChange={(e, value) => onChange(value)}
              />
            );
          }}
        </FormDataConsumer>
      </Labeled>
    </FormControl>
  );
}
